import { useQueryClient } from "@tanstack/vue-query";

const useInvalidateQuery = () => {
  const queryClient = useQueryClient();
  const invalidateQuery = (queryKey: unknown[]) => {
    queryClient.invalidateQueries(queryKey);
  };

  return {
    invalidateQuery,
  };
};

export default useInvalidateQuery;
